import { useNavigate } from 'react-router-dom';

const CURRICULUM_OBJECTIVES = [
  'To develop a strong Islamic identity that will allow them to withstand the multi-cultural society.',
  'To develop and nurture a sense of Taqwa and accountability into the consciousness of our students.',
  'To understand and appreciate the Sunnah of the Prophet S.A.W. as a perfect role model.',
  'To understand and appreciate Islamic ethics in guiding the humanity to a prosperous path in this life and the next.',
  'To equip the students with the basics of Islamic knowledge and history which enables them to have an Islamic perspective on contemporary issues.',
  'To understand and appreciate the concept of worship and its manifestation in our daily activities.',
  'To inculcate a sense of servitude to Allah into the hearts of our students.',
  'To develop a sense of community and continuity through mentorship and leadership training.',
];

const TEACHING_STEPS = [
  {
    title: 'Comprehension (Ta\'qqul)',
    body: 'The Qur\'an uses parables, practical examples, logical reasoning, and other compelling techniques to make things clear. Comprehension is the gateway to understanding Islam. Comprehension is achievable when the teacher finds a way to present the topic in a way which is understandable and relatable to the students.',
  },
  {
    title: 'Contemplation (Tafakur & Tadabbur)',
    body: 'Transforming the knowledge from the mind to the heart is a process which takes a long time. Tafakur helps our students to think deeply about the topics they are learning. In this step, the teacher should ask the students to write summaries, reflections, and group projects; this will help the students to go beyond simple memorization to deeper understanding.',
  },
  {
    title: 'Appreciation (Taddakur)',
    body: 'Through appreciation, our students shall value and appreciate the long-term goals of this curriculum.',
  },
];

const PROGRAM_LEVELS = [
  {
    level: 'Level I',
    courses: [
      { nameEn: 'Islamic Aqeeda I', nameAr: 'العقيدة الإسلامية ١', desc: 'This course introduces students to the basics of Islamic Aqeeda: the definition of Islam, Iman, and Ihsan; the concept of Ibadah and its different manifestation in our lives.' },
      { nameEn: 'Fiqh of Worship I', nameAr: 'فقه العبادات ١', desc: 'This course introduces students to the basics of Tahara (purification), its different types, and the book of Salah.' },
      { nameEn: 'Tazkiya & Ethics I', nameAr: 'التزكية والأخلاق ١', desc: 'This course is designed to acquaint the students with the basics of Tazkiah and its relevance in the modern world. Students will learn the meaning of the daily Adkar and how to utilize them in our daily lives. Students will also learn the supplications of the Prophet S.A.W.' },
    ],
  },
  {
    level: 'Level II',
    courses: [
      { nameEn: 'Islamic Aqeeda II', nameAr: 'العقيدة الإسلامية ٢', desc: 'This course introduces students to Asmaa\'ullahi Al-Husna. Students will learn the names of Allah, their meanings, and their functions. By the end of this course students shall comprehend, contemplate, and appreciate the role of Allah\'s names and attributes in our lives and the universe.' },
      { nameEn: 'Fiqh of Worship II', nameAr: 'فقه العبادات ٢', desc: 'This course takes the students to the next level of Fiqh of Worship. Upon completing this course, students shall know the rules and objectives regarding fasting, Zakat, and Hajj.' },
      { nameEn: 'Tazkiya & Ethics II', nameAr: 'التزكية والأخلاق ٢', desc: 'This course takes the students to the next level of Tazkiah. Upon completing this course, students shall know the meaning and the relevance of these different stations: Muraqabah (vigilance), Ihsan (excellence), Yaqeen (certainty), and other topics that are essential in Tazkiah.' },
    ],
  },
  {
    level: 'Level III',
    courses: [
      { nameEn: 'Tafseer I', nameAr: 'تفسير جزء عم', desc: 'In this tafseer class our students will learn the meaning of Juz Amma and the meaning of the main vocabularies in Juz 30.' },
      { nameEn: 'Seerah Course', nameAr: 'السيرة النبوية', desc: 'This course introduces students to the major events in the Seerah of the Prophet S.A.W. Upon completing this course, students shall understand and appreciate the role of the Prophet S.A.W in delivering humanity from darkness to the light of Islam.' },
      { nameEn: 'Tazkiya & Ethics III', nameAr: 'التزكية والأخلاق ٣', desc: 'This course takes the students to the next level of Tazkiah. Upon completing this course, students shall know the deeper meaning of Salah and its inner dimensions.' },
    ],
  },
  {
    level: 'Level IV',
    courses: [
      { nameEn: 'Tafseer II', nameAr: 'التفسير', desc: 'This course takes the students to the next level of Tafseer. In this tafseer class our students will learn the meaning of Juz Tabarak and the meaning of the main vocabularies in Juz 29.' },
      { nameEn: 'Hadith Course', nameAr: 'علم الحديث', desc: 'This course introduces our students to the importance of the Sunnah of the Prophet S.A.W, the prophetic method of raising a successful generation, his mercy and caring for humanity, and how his Sunnah was recorded and preserved throughout all ages.' },
      { nameEn: 'Arabic: Reading & Writing I', nameAr: 'اللغة العربية: القراءة والكتابة', desc: 'This course introduces students to the rudiments of Arabic language, writing and reading. Students will learn the basic alphabet and how to form Arabic sentences.' },
    ],
  },
  {
    level: 'Level V',
    courses: [
      { nameEn: 'Tafseer III', nameAr: 'التفسير', desc: 'This course takes the students to the third level of Tafseer. In this tafseer class our students will learn the meaning of Juz Al-Mujadalah and the meaning of the main vocabularies in Juz 28.' },
      { nameEn: 'Arabic: Reading & Writing II', nameAr: 'اللغة العربية: القراءة والكتابة', desc: 'This course takes the students to the next level of Arabic language. Students will practice reading and writing. Upon completing this course, students will be able to read Arabic without difficulty.' },
      { nameEn: 'History of Islam in America', nameAr: 'تاريخ الإسلام في أمريكا', desc: 'This course teaches our students the roots of Islam in America: the early Muslim settlers in America, the African Muslim slaves, and the Muslim immigrants. Upon completing this course, our students shall understand and appreciate the presence of Muslims in America since its inception and that they are not foreigners.' },
    ],
  },
  {
    level: 'Level VI',
    courses: [
      { nameEn: 'Introduction to Maqaasid Ash-Sharia', nameAr: 'مقاصد الشريعة', desc: 'This course teaches our students the main objectives of the Sharia, and the reasoning and wisdom behind the Halal and Haram in Islam. Upon completing this course our students shall understand and appreciate the role of Sharia in ameliorating the human condition.' },
      { nameEn: 'Fiqh of Contemporary Issues', nameAr: 'قضايا فقهية معاصرة', desc: 'This course introduces our students to the Islamic stance on modern issues. Students will learn modern issues from an Islamic perspective. The goal of this course is to equip Muslim students with the intellectual fortitude that allows them to make Islam relevant in this ever-changing world.' },
      { nameEn: 'Advanced Seerah & History of Islamic Civilization', nameAr: 'دراسات متقدمة في السيرة النبوية', desc: 'Students will learn the intellectual and emotional aspects of the Seerah. Moreover, students will learn how to make events of Seerah relevant in our modern world. Upon completing this course, students shall understand and appreciate the role of Islam in delivering humanity from darkness to the light of Islam.' },
    ],
  },
];

export default function CurriculumPage() {
  const navigate = useNavigate();

  return (
    <div className="elegant-font min-h-screen bg-white text-neutral-900">
      <header className="sticky top-0 z-30 border-b border-neutral-200 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <button
                onClick={() => navigate('/')}
                className="p-2 text-neutral-600 hover:text-neutral-900"
                aria-label="Back to home"
              >
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
              </button>
              <img src="/logo.jpeg" alt="Abubakar Islamic Institute" className="h-10 w-auto object-contain" />
              <h1 className="font-elegant-display text-lg font-semibold text-neutral-900">Curriculum</h1>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-8 pb-16">
        <p className="font-elegant text-center text-neutral-600 mb-12">
          A Two-Year Islamic Sciences Program
        </p>

        {/* Letter from Imam */}
        <section className="mb-16">
          <p className="font-elegant text-2xl text-primary-700 text-center mb-6" dir="rtl" lang="ar">
            بسم الله الرّحمن الرّحيم
          </p>
          <p className="font-elegant text-sm text-neutral-500 text-center mb-6">In the Name of Allah, the Compassionate, the Merciful</p>
          <div className="space-y-4 font-elegant text-neutral-700 leading-relaxed">
            <p>Dear parent, please take a look at this curriculum. We present this curriculum to make you aware of the curriculum we teach at Abubakar Islamic Institute (known as Machad).</p>
            <p>We are committed—through our Comprehensive Islamic Studies Curriculum—to produce well rounded leaders who understand their Deen in depth, have strong Islamic identity, can withstand modern challenges and its deleterious impact, and can carry out the legacy of Islam to the next generation.</p>
            <p>We ask Allah to accept from us and to grant us sincerity in actions and words.</p>
          </div>
          <p className="font-elegant font-semibold text-neutral-900 mt-8">Imam Mowlid Ali</p>
          <p className="font-elegant text-sm text-neutral-600">Imam and Head of Abubakar Islamic Institute</p>
        </section>

        {/* Curriculum Objectives */}
        <section className="mb-16">
          <h2 className="font-elegant-display text-2xl font-semibold text-neutral-900 text-center mb-8 tracking-tight">
            Curriculum Objectives
          </h2>
          <ul className="space-y-3">
            {CURRICULUM_OBJECTIVES.map((item, i) => (
              <li key={i} className="font-elegant text-neutral-700 leading-relaxed flex gap-3">
                <span className="text-primary-600 mt-1.5 shrink-0">•</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </section>

        {/* Method of Teaching */}
        <section className="mb-16">
          <h2 className="font-elegant-display text-2xl font-semibold text-neutral-900 text-center mb-4 tracking-tight">
            Method of Teaching Policy
          </h2>
          <p className="font-elegant text-neutral-600 text-center mb-8 leading-relaxed">
            Our primary goal is to make our students understand and engage with the subject intimately. Therefore, the teacher must inform the students of the benefits, the main concepts, and the long-term goals of the subject. For our students to arrive at important understanding of Islam, the teacher should go through these three steps with the students.
          </p>
          <div className="space-y-6">
            {TEACHING_STEPS.map((step, i) => (
              <div key={i} className="bg-neutral-50 rounded-2xl p-6 border border-neutral-200/60">
                <h3 className="font-elegant-display text-lg font-semibold text-neutral-900 mb-3">{i + 1}. {step.title}</h3>
                <p className="font-elegant text-neutral-700 leading-relaxed">{step.body}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Overview of the Program */}
        <section>
          <h2 className="font-elegant-display text-2xl font-semibold text-neutral-900 text-center mb-8 tracking-tight">
            Overview of the Program
          </h2>
          <div className="space-y-8">
            {PROGRAM_LEVELS.map(({ level, courses }) => (
              <div key={level} className="bg-white rounded-2xl overflow-hidden shadow-soft border border-neutral-200/60">
                <div className="bg-primary-600 px-6 py-3">
                  <h3 className="font-elegant-display text-xl font-semibold text-white tracking-tight">{level}</h3>
                </div>
                <div className="p-6 sm:p-8 space-y-6">
                  {courses.map((course, i) => (
                    <div key={i} className="border-b border-neutral-100 last:border-0 last:pb-0 pb-6 last:pb-0">
                      <div className="flex flex-wrap items-baseline gap-2 mb-2">
                        <span className="font-elegant-display font-semibold text-neutral-900">{course.nameEn}</span>
                        <span className="font-elegant text-neutral-500 text-sm" dir="rtl" lang="ar">{course.nameAr}</span>
                      </div>
                      <p className="font-elegant text-neutral-600 text-sm leading-relaxed">{course.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}
